import * as RadioGroup from '@radix-ui/react-radio-group';
import classNames from 'classnames';
import { ComponentProps, ReactNode, useId } from 'react';
import { useAccentBgContext } from '../accent-bg-context/accent-bg-context';
import styles from './radio.module.scss';

type Props = {
  children: string | ReactNode;
  indicator: ReactNode;
  focused?: boolean;
} & Partial<ComponentProps<typeof RadioGroup.Item>>;

/**
 * The Radio component can be used standalone and also supports being used as "RadixSelect.Item".
 */

export const Radio: React.FC<Props> = ({ children, indicator, focused, className, ...rest }) => {
  const radioId = useId();
  const { isAccentBackground } = useAccentBgContext();
  return (
    <button
      className={classNames(
        styles.root,
        {
          [styles.isAccentBg]: isAccentBackground,
          [styles.disabled]: rest.disabled,
          [styles.checked]: rest.checked,
          [styles.focused]: focused,
        },
        className,
      )}
      {...rest}
    >
      <span className={styles.radioButton} id={radioId}>
        <div className={styles.indicatorContainer}>{indicator}</div>
      </span>
      <label className={styles.label} htmlFor={radioId}>
        {children}
      </label>
    </button>
  );
};
